<template>
  <div ref="container">
    <span
      :id="'tooltip_' + _uid"
      class="text-ellipsis word-break body-2 text--primary"
      v-if="text"
      @click="onClickHandler"
    >
      {{ text }}
      <v-tooltip
        top
        v-if="isOverflowing"
        :max-width="tooltipWidth"
        :activator="'#tooltip_' + _uid"
      >
        <span v-text="text" />
      </v-tooltip>
    </span>
  </div>
</template>

<script>
/**
 * Implement ellipsis on the text
 */
export default {
  name: "TextEllipsis",
  /**
   * ---------- Data Attributes ----------------
   */
  data() {
    return {
      isOverflowing: false,
    };
  },
  /**
   * Watch property
   */
  watch: {
    text() {
      this.checkOverflow();
    },
  },
  /**
   * ---------------- Custom Events ------------------
   */
  emits: ["clicked"],
  /**
   * ---------------- Props ------------------
   */
  props: {
    /**
     * Text to be shown in the tooltip
     */
    text: { type: String, required: true },
    /**
     * Width of the tooltip content
     */
    tooltipWidth: { type: [String, Number], default: "" },
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    /**
     * Text wrapper click handler
     * @emits clicked
     */
    onClickHandler() {
      this.$emit("clicked");
    },

    /**
     * Check for overflow
     * @returns {Boolean}
     */
    checkOverflow() {
      this.$nextTick(() => {
        // Code that will run only after the
        this.isOverflowing = this.$refs.container?.offsetHeight > 30;
        // entire view has been rendered
      });
    },
  },
  /**
   * Mounted lifecycle
   */
  mounted() {
    this.checkOverflow();
  },
};
</script>

<style lang="scss" scoped>
.text-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
